import { MtProjectUser } from "server/models"
import { VALUE, UNLIMITED } from "const"
import { GET, DELETE, POST } from "client/store/utils"
import { PackageSettings, ProjectUserList, LangType } from "client/store"


export const LoadAllProjectUsers = () => (
    GET("/mtProjectUser/all")
    .then((rows: MtProjectUser[]) => {
        const projectUserList: ProjectUserList = {}
        rows.forEach((row) => {
            const userIds: number[] = projectUserList[row.projectId] ? projectUserList[row.projectId].slice() : []
            userIds.push(row.userId)
            projectUserList[row.projectId] = userIds
        })
        return projectUserList
    })
)

export const LoadProjectUsers = (projectId: number) => (
    GET(`/mtProjectUser/projectId/${projectId}`)
    .then((rows: MtProjectUser[]) => {
        const userIds: number[] = []
        rows.forEach((row) => {
            userIds.push(row.userId)
        })
        return userIds
    })
)

export const AddProjectUser = (userIds: readonly number[], projectId: number, maxTeamMembers: number) => (
    // load actual user list before adding
    LoadProjectUsers(projectId).then((assignedUserIds) => {
        let newUsers: MtProjectUser[] = []
        userIds.forEach((userId) => {
            if (!assignedUserIds.includes(userId)) {
                newUsers.push({
                    userId,
                    projectId,
                })
            }
        })

        // limit number of users according to package settings
        if (maxTeamMembers !== null) {
            const length = maxTeamMembers - assignedUserIds.length
            newUsers = newUsers.slice(0, length > 0 ? length : 0)
        }

        return POST(
            "/mtProjectUser/add",
            JSON.stringify(newUsers),
        )
    })
)

export const SaveProjectUserList = (userIds: readonly number[], projectId: number) => {
    const newUsers: MtProjectUser[] = []
    userIds.forEach((userId) => {
        newUsers.push({
            userId,
            projectId,
        })
    })

    return POST(
        "/mtProjectUser/save",
        JSON.stringify(newUsers),
    )
}

export const DeleteProjectUser = (userId: number, projectId: number) => (
    DELETE(`/mtProjectUser/delete/${userId}/${projectId}`)
    .then((removedRows: number) => removedRows)
)

export const GetMaxProjectUsers = (
    packageSettings: PackageSettings,
    userNumber?: number,
    lang?: LangType,
) => {
    const { projectTeamMembers, projectTeamMembersValue } = packageSettings
    let maxTeamMembers = 0
    if (projectTeamMembers === 1) maxTeamMembers = 1
    if (projectTeamMembers === VALUE && projectTeamMembersValue) maxTeamMembers = projectTeamMembersValue
    if (projectTeamMembers === UNLIMITED) maxTeamMembers = null

    if (userNumber !== undefined && lang) {
        let feedback: string
        if (maxTeamMembers === null) {
            feedback = lang.maxTeamMembersUnlimited
        } else {
            if (userNumber < maxTeamMembers) feedback = lang.maxTeamMembers
            if (userNumber === maxTeamMembers) feedback = lang.maxTeamMembersReached
            if (userNumber > maxTeamMembers) feedback = lang.maxTeamMembersExceeded
            feedback = feedback.replace("{0}", maxTeamMembers.toString())
        }

        const maxNumberReached = maxTeamMembers !== null && userNumber >= maxTeamMembers
        const maxNumberExceeded = maxTeamMembers !== null && userNumber > maxTeamMembers

        return {
            maxTeamMembers,
            feedback,
            maxNumberReached,
            maxNumberExceeded,
        }
    }

    return { maxTeamMembers }
}
